  // Utility to strip markdown for TTS
  export function stripMarkdown(md: string): string {
    return md
      .replace(/!\[.*?\]\(.*?\)/g, '') // remove images
      .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1') // remove links but keep text
      .replace(/`{1,3}[^`]*`{1,3}/g, '') // remove inline code and code blocks
      .replace(/[*_~#>`-]/g, '') // remove *, _, ~, #, >, `, -
      .replace(/\\([\\`*_{}\[\]()#+\-.!])/g, '$1') // remove escaped markdown
      .replace(/\n{2,}/g, '\n') // collapse multiple newlines
      .replace(/>+/g, '') // remove blockquotes
      .replace(/#+\s/g, '') // remove heading hashes
      .replace(/[*_~]/g, '') // remove emphasis
      .replace(/`/g, '') // remove code ticks
      .replace(/^\s+|\s+$/g, '') // trim
      ;
  }